<template lang="pug">
   ._flex(style="max-width: 100px")
      input.SlideToggle-input(type="checkbox" :checked="value" @change="onChange")
</template>

<style lang="sass" scoped>

input[type='checkbox'].SlideToggle-input
   appearance: none
   width: 3em
   height: 1.5em
   background-color: $grey-300
   border-radius: 3em
   position: relative
   cursor: pointer
   outline: none
   transition: left 0.14s ease-in-out, background-color 0.14s ease-in-out

input[type='checkbox'].SlideToggle-input:checked
   background-color: $light-blue-vivid-500

// Circle
input[type='checkbox'].SlideToggle-input:after
   position: absolute
   content: ''
   width: 1.5em
   height: 1.5em
   border-radius: 50%
   background-color: #fff
   box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3)
   transform: scale(0.7)
   left: 0
   transition: left 0.14s ease-in-out, background-color 0.14s ease-in-out

input[type='checkbox'].SlideToggle-input:checked:after
   left: calc(100% - 1.5em)
</style>

<script>
export default {
   name: 'SlideToggle',
   props: ['value', 'customChangeHandler'],
   methods: {
      onChange(e) {
         this.$emit('input', e.target.checked)
         if (this.customChangeHandler) {
            this.customChangeHandler()
         }
      },
   },
}
</script>

